import BaseGrid from "../sections/view";
import { text, statusBadge, userAvatar } from "../../helpers/templates";

export default class GridView extends BaseGrid {
	config() {
		const _ = this.app.getService("locale")._;

		const ui = super.config();
		webix.extend(
			ui,
			{
				rowHeight: Math.max(
					webix.skin.$active.rowHeight +
						Math.round(webix.skin.$active.rowHeight * 0.55),
					40
				),
				headerRowHeight: webix.skin.$active.barHeight + 10,
			},
			true
		);
		ui.columns = [
			{
				id: "avatar",
				header: "",
				width: 70,
				css: "webix_um_center_column ",
				template: user => {
					return userAvatar(
						user,
						"webix_um_member_avatar webix_um_member_avatar_big"
					);
				},
			},
			{
				id: "name",
				header: _("Full Name"),
				fillspace: 2,
				sort: "string",
				template: text(this),
			},
			{
				id: "status",
				header: _("Status"),
				width: 150,
				template: (data, type, value) => statusBadge(value, _),
			},
			{
				id: "email",
				header: _("Email"),
				fillspace: 2,
				sort: "string",
				template: text(this),
			},
		];

		return ui;
	}

	init() {
		const users = this.app.getService("local").users(true);
		this.InitSelf(users, this.getParam("id", true));
	}

	ShowDetails(id) {
		this.getParentView().ShowDetails(id);
	}

	SearchCompare(value, user) {
		return (
			user.name.toLowerCase().indexOf(value) > -1 ||
			user.email.toLowerCase().indexOf(value) > -1
		);
	}
}
